import React from "react";
import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import useRoomInfo from "../../../utils/hooks/useRoomInfo";

type Props = {
  isOpen: boolean;
  roomName: string;
  id?: number;
};
const CarouselInfo = ({ isOpen, roomName, id }: Props) => {
  const isTabletOrMobile = useMediaQuery("(max-width: 768px)"); // Definisci il breakpoint per tablet e mobile
  const { description, name } = useRoomInfo(roomName);
  const isTablet = useMediaQuery("(min-width: 768px)");
  return (
    <Box
      sx={{
        width: isTabletOrMobile ? "100%" : "100%",
        height: "100%",
        zIndex: 1000,
        display: !isTabletOrMobile || isOpen ? "flex" : "none",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: isTabletOrMobile ? 4 : "80px 0 40px 0",
      }}
    >
      <Stack
        width={isTabletOrMobile ? "100%" : "70%"}
        height={isTabletOrMobile ? "100%" : "70%"}
      >
        <Typography
          variant="body1"
          sx={{
            textAlign: "center",
            color: isTabletOrMobile ? "#000" : "#1f5f91",
            letterSpacing: "1.3px",
            paddingTop: isTabletOrMobile ? "5px" : undefined,
            fontFamily: "ivymode",
            fontSize: isTabletOrMobile ? "20px" : "28px",
          }}
        >
          {name}{" "}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            lineHeight: isTabletOrMobile ? "1.5" : undefined,
            textAlign: "center",
            paddingTop: isTabletOrMobile ? "15px" : "30px",
            fontSize: isTabletOrMobile ? "14px" : "16px",
          }}
        >
          {description}
        </Typography>
      </Stack>
    </Box>
  );
};

export default CarouselInfo;
